import { Injectable } from '@angular/core';
import { Http , Response} from '@angular/http';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { Utils } from './../shared/utils';
import 'rxjs/add/operator/toPromise';
import { Unidade } from './unidade';

@Injectable()
export class UnidadeService {

  private unidadeUrl = '/unidade';

  constructor(
    private http: Http,
    private _flashMessagesService: FlashMessagesService,
    private utils: Utils
  ) {

  }

  getUnidades(): Promise<Unidade[]> {
    return this.http.get(this.unidadeUrl)
                .toPromise()
                .then(response => response.json().dados as Unidade[])
                .catch((error) => this.handleError(error));
  }

  getUnidadesPorCentro(id?:number): Promise<Unidade[]> {
    let url: string  = this.unidadeUrl + '/pegarPorCentro/' + id;

    return this.http.get(url)
                .toPromise()
                .then(response => response.json().dados as Unidade[])
                .catch((error) => this.handleError(error));
  }

  getUnidade(id: number): Promise<Unidade>{
    let url: string  = this.unidadeUrl + '/' + id;
    return this.http.get(url)
               .toPromise()
               .then(response => response.json().dados as Unidade)
               .catch((error) => this.handleError(error));
  }

  saveUnidade(unidade: Unidade): Promise<Response>{
    let url: string = this.unidadeUrl;

    if(unidade.id !== undefined)
      url = url + '/' + unidade.id;

    return this.http
               .post(url, this.utils.buildFormData(unidade))
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  deleteUnidade(unidade: Unidade): Promise<Response>{
    let url: string = this.unidadeUrl + '/' + unidade.id ;
    return this.http
               .delete(url)
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  private handleSuccess(resp: any): Promise<any> {
    this.utils.flashMessage(resp.msg, 'success');
    //this._flashMessagesService.show(resp.msg, { cssClass: 'card alert-success', timeout: 5000 });
    return resp;
  }

  private handleError(error: any): Promise<any> {
     switch (error.status) {
      case 500:
        this.utils.flashMessage('Ocorreu error no servidor, entre em contato com o administrador.', 'danger');
        //this._flashMessagesService.show("Ocorreu error no servidor, entre em contato com o administrador.", { cssClass: 'card alert-danger', timeout: 5000 });
        break;
      case 403:
        this.utils.flashMessage(error.json().msg, 'warning');
        //this._flashMessagesService.show(error.json().msg, { cssClass: 'card alert-warning', timeout: 5000 });
        break;
      default:
      this.utils.flashMessage("Ocorreu um error, tente novamente mais tarde.", 'danger');
        //this._flashMessagesService.show("Ocorreu um error, tente novamente mais tarde.", { cssClass: 'card alert-danger', timeout: 5000 });
    }
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/unidades/unidade.service.ts